import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './WhyChoose.css';

const slides = [
    {
        subtitle: "WHY CHOOSE PRIME REHAB",
        heading: "Complete Rehabilitation Solutions for Clinics & Hospitals",
        image: "https://primerehabindustries.in/Image/Home/Tab1.jpg",
        buttonText: "Explore Equipment",
        link: "/products"
    },
    {
        subtitle: "WHY CHOOSE PRIME REHAB",
        heading: "Advanced Physiotherapy Equipment for Modern Therapy Centers",
        image: "https://primerehabindustries.in/Image/Home/Tab2.jpg",
        buttonText: "View Products",
        link: "/products"
    },
    {
        subtitle: "WHY CHOOSE PRIME REHAB",
        heading: "ADL Training Environments for Rehabilitation Therapy",
        image: "https://primerehabindustries.in/Image/Home/Tab3.png",
        buttonText: "Explore ADL Solutions",
        link: "/services?tab=adl"
    },
    {
        subtitle: "WHY CHOOSE PRIME REHAB",
        heading: "Specialized Pediatric Therapy Solutions",
        image: "https://primerehabindustries.in/Image/Home/Tab4.jpg",
        buttonText: "View Pediatric Solutions",
        link: "/services?tab=pediatric"
    }
];

const WhyChoose = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    const handleNext = useCallback(() => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, [isAnimating]);

    const handlePrev = useCallback(() => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    }, [isAnimating]);

    // Auto slide
    useEffect(() => {
        const interval = setInterval(handleNext, 6000);
        return () => clearInterval(interval);
    }, [handleNext]);

    useEffect(() => {
        const timer = setTimeout(() => setIsAnimating(false), 800);
        return () => clearTimeout(timer);
    }, [currentIndex]);

    return (
        <section className="why-choose-section">
            <div className="why-choose-container">
                <div className="why-choose-slider-wrapper">
                    <div 
                        className="why-choose-slides-track" 
                        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                    >
                        {slides.map((slide, index) => (
                            <div className="why-choose-slide" key={index}>
                                <div className="why-choose-content">
                                    <span className="slide-subtitle">{slide.subtitle}</span>
                                    <h2 className="slide-heading">{slide.heading}</h2>
                                    <Link to={slide.link} className="slide-btn">
                                        {slide.buttonText}
                                    </Link>
                                </div>
                                <div className="why-choose-image-container">
                                    <img src={slide.image} alt={slide.heading} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="why-choose-nav-controls">
                    <button className="slide-nav-btn prev" onClick={handlePrev} aria-label="Previous">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                    </button>
                    <button className="slide-nav-btn next" onClick={handleNext} aria-label="Next">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </button>
                   
                </div>
            </div>
        </section>
    );
};

export default WhyChoose;
